import { Injectable } from '@angular/core';
import { CompanyInventorySearch } from '../models/CompanyInventorySearch';
import { HttpClient } from '../shared/wrappers/HttpClient';
import { ConsultantService } from './consultant.service';
import { UrlBuilder } from '../models/utils/url-builder.model';
import { CompanyInventoryModel } from '../models/CompanyInventory.model';

@Injectable()
export class CompanyInventoryService {
    private endPoint: String = "/company-inventory";

    constructor(private httpClient: HttpClient) {
    }

    async create(companyInventory: CompanyInventoryModel): Promise<CompanyInventoryModel> {
        return await this.httpClient.post(this.endPoint, companyInventory)
    }

    async searchCompanies(companyInventory: CompanyInventorySearch, project: string = ""): Promise<CompanyInventoryModel[]> {
        
        const keyParams = [
            { key: "active", value: companyInventory.active },
            { key: "companyGroup", value: companyInventory.companyGroup },
            { key: "customer", value: companyInventory.customer},
            { key: "industry", value: companyInventory.industry},
            { key: "contractType", value: companyInventory.contractType},
            { key: "readjustmentIndex", value: companyInventory.readjustmentIndex},
            { key: "excellenceCenter", value: companyInventory.excellenceCenter},
            { key: "readjustmentIndex", value: companyInventory.readjustmentIndex},
        ]

        const builder = new UrlBuilder([
            { key: "skip", value: companyInventory.skip },
            { key: "limit", value: companyInventory.limit },
            ...keyParams
        ]);

        if (project !== '')
            builder.addQueryStringParamsInsideProject(project);

        let url = builder.buildUrl(`${this.endPoint}`);
        let response = await this.httpClient.get(url);
        let companyInventoryModel = new Array<CompanyInventoryModel>();
        if(!response){
        companyInventory.totalItems = 0;
        return companyInventoryModel
        }
        companyInventory.totalItems = response.totalItems;
        for (let c of response.companyInventory) {
            var con = new CompanyInventoryModel();
            con.loadCompanyForGrid(c)
            companyInventoryModel.push(con);

        }

        return companyInventoryModel;
    }

    async getById(id: string): Promise<CompanyInventoryModel> {
        return await this.httpClient.get(`${this.endPoint}/${id}`)
    }

    async edit(companyInventory: CompanyInventoryModel): Promise<CompanyInventoryModel> {
        return await this.httpClient.update(`${this.endPoint}`, companyInventory._id, companyInventory)
    }
}



// WEBPACK FOOTER //
// ./src/app/services/companyInventory.service.ts